import store from "../appStore";

export const fadeToBlack = (callback) => {
  store.faded = true;
  setTimeout(() => {
    setTimeout(() => {
      store.faded = false;
    }, 150);
    callback();
  }, 450);
};
